"use client";

import { useServer } from "@/components/providers/ServerProvider";

export default function MobileHeader() {
  const { online } = useServer();

  return (
    <header className="md:hidden sticky top-0 z-30 h-16 bg-[#151719]/95 backdrop-blur border-b border-white/10 px-4 flex items-center justify-between">

      <div>
        <p className="text-[10px] text-gray-500 uppercase tracking-wider">
          Server
        </p>

        <h1 className="font-semibold">
          My Server
        </h1>
      </div>

      <div className="flex items-center gap-2">

        <span
          className={`h-2.5 w-2.5 rounded-full ${
            online
              ? "bg-green-400"
              : "bg-red-400"
          }`}
        />

        <span className="text-xs text-gray-400">
          {online ? "Online" : "Offline"}
        </span>

      </div>

    </header>
  );
}